module.exports = __webpack_public_path__ + "img/menu_ico.457d3e72.png";